import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { RecommendationsGalleryMiniCartSection } from './components/RecommendationsGalleryMiniCartSection/RecommendationsGalleryMiniCartSection.js';
import { RecommendationsGalleryPageSection } from './components/RecommendationsGalleryPageSection/RecommendationsGalleryPageSection.js';
import { isValidRecommendation } from './utils/is-valid-recommendation.js';

const componentMap = {
    page: RecommendationsGalleryPageSection,
    minicart: RecommendationsGalleryMiniCartSection
};
const RecommendationListContainer = ({ layout ='minicart' , isLoading , recommendations ,  })=>{
    const { getLabel  } = useIntl();
    if (isLoading || !recommendations.length) {
        return null;
    }
    const Component = componentMap[layout] || RecommendationsGalleryMiniCartSection;
    const validRecommendations = recommendations.filter(isValidRecommendation);
    if (!validRecommendations.length) return null;
    return /*#__PURE__*/ React.createElement(Component, {
        title: getLabel('products.recommendationList.title'),
        recommendations: recommendations
    });
};

export { RecommendationListContainer };
//# sourceMappingURL=RecommendationListContainer.js.map
